import { render } from "./PettyCash.vue?vue&type=template&id=a4c76cb8&scoped=true"
import script from "./PettyCash.vue?vue&type=script&lang=js"
export * from "./PettyCash.vue?vue&type=script&lang=js"

import "./PettyCash.vue?vue&type=style&index=0&id=a4c76cb8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4c76cb8"]])

export default __exports__